module.exports = __webpack_public_path__ + "img/H5_8.8cf22e7c.png";